import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';

import CrossSellHands from '../../assets/crossSellHands.svg';

export const CrossSellCardIntro = () => {
  return (
    <div>
      <div className="flex justify-center">
        <img src={CrossSellHands} alt="" />
      </div>
      <div className="mb-l text-l font-med">
        Borrow <b>£1,000-£1,000,000</b> with iwoca today
      </div>
      <div className="mb-l text-s font-reg">
        It only takes a few minutes to find out how much you can borrow.
      </div>
      <Button
        type="submit"
        variant="secondary"
        className="w-full"
        onClick={() => tracking.ampli.clickedXSellBanner()}
      >
        See what you can borrow
      </Button>
    </div>
  );
};
